var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "zoom-btns-container" }, [
    _c(
      "div",
      {
        staticClass: "zoom-btn top-radius",
        on: {
          click: function ($event) {
            return _vm.zoom(1)
          },
        },
      },
      [_c("fa", { attrs: { icon: ["fas", "plus"], size: "sm" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "zoom-btn bottom-radius",
        on: {
          click: function ($event) {
            return _vm.zoom(-1)
          },
        },
      },
      [_c("fa", { attrs: { icon: ["fas", "minus"], size: "sm" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }